/* ═══════════════════════════════════════════════════════════════
   PiARIS — Product Gradients
   Theme-independent gradient definitions per product.
   White text on saturated backgrounds works in both light/dark mode.
   © 2026 Pi Consultants · pi-consulting.us
   ═══════════════════════════════════════════════════════════════ */

/** Per-product gradient stops, primary/accent colors, and label.
    Used by ProductLockup, SubViewHero, and showcase heroes. */
var PRODUCT_GRADIENTS = {
  watchtower: {
    name: "Watchtower",
    icon: "\uD83C\uDF10",
    hero: "linear-gradient(135deg, #1E1B4B 0%, #312E81 30%, #4F46E5 65%, #0891B2 100%)",
    border: "#4F46E5",
    pri: "#4F46E5",
    accent: "#0891B2",
    pillBg: "rgba(129, 140, 248, 0.18)",
    pillBorder: "rgba(165, 180, 252, 0.35)",
    glow: "rgba(79, 70, 229, 0.4)"
  },
  docmaya: {
    name: "DocMaya",
    icon: "\uD83D\uDCC4",
    hero: "linear-gradient(135deg, #064E3B 0%, #065F46 25%, #059669 55%, #0D9488 80%, #06B6D4 100%)",
    border: "#059669",
    pri: "#059669",
    accent: "#06B6D4",
    pillBg: "rgba(110, 231, 183, 0.18)",
    pillBorder: "rgba(167, 243, 208, 0.35)",
    glow: "rgba(5, 150, 105, 0.4)"
  },
  a11ylab: {
    name: "PA11Y Lab",
    icon: "\uD83E\uDDEA",
    hero: "linear-gradient(135deg, #4C1D95 0%, #7C3AED 25%, #8B5CF6 50%, #EC4899 80%, #3B82F6 100%)",
    border: "#8B5CF6",
    pri: "#8B5CF6",
    accent: "#EC4899",
    pillBg: "rgba(196, 181, 253, 0.18)",
    pillBorder: "rgba(221, 214, 254, 0.35)",
    glow: "rgba(139, 92, 246, 0.4)"
  },
  deltarecon: {
    name: "Delta Recon",
    icon: "\u0394",
    hero: "linear-gradient(135deg, #78350F 0%, #92400E 25%, #D97706 55%, #EA580C 80%, #DC2626 100%)",
    border: "#D97706",
    pri: "#D97706",
    accent: "#DC2626",
    pillBg: "rgba(251, 191, 36, 0.18)",
    pillBorder: "rgba(253, 224, 71, 0.35)",
    glow: "rgba(217, 119, 6, 0.4)"
  }
};

export { PRODUCT_GRADIENTS };
